import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import CBHeaderTextWithHelp from '../../shared/CBHeaderTextWithHelp';
import CBButtonWithIconSmall from '../../shared/CBButtonWithIconSmall';
import CBSpinnerFloating from '../../shared/CBSpinnerFloating';
import LeasingAgreementForm from './LeasingAgreementForm';
import {
  fetchLeasingAgreements as _fetchLeasingAgreements,
  createLeasingAgreement as _createLeasingAgreement,
  updateLeasingAgreement as _updateLeasingAgreement,
  deleteLeasingAgreement as _deleteLeasingAgreement,
} from '../../../actions/leasingAgreementActions';

// Vuokra-/leasingsopimukset of the organization being edited on admin.ovio.fi.
// Only Ovio staff maintain them: each one lets the organization add cars that
// Traficom says belong to the leasing company, until its end date.
class StaffLeasingAgreements extends React.Component {
  state = {
    newFormKey: null,
    newFormCount: 0,
  };

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    const { organizationId, savedFormKey } = this.props;
    const { newFormKey } = this.state;
    if (organizationId !== prevProps.organizationId) {
      this.fetch();
      this.closeNewForm();
    }
    // The API middleware resolves .then() with undefined: close the new form
    // once its create has landed in the store.
    if (newFormKey && savedFormKey === newFormKey && prevProps.savedFormKey !== savedFormKey) {
      this.closeNewForm();
    }
  }

  fetch = () => {
    const { organizationId, fetchLeasingAgreements } = this.props;
    if (organizationId) {
      fetchLeasingAgreements(organizationId);
    }
  };

  openNewForm = () => {
    const { newFormCount } = this.state;
    this.setState({ newFormKey: `new-${newFormCount + 1}`, newFormCount: newFormCount + 1 });
  };

  closeNewForm = () => this.setState({ newFormKey: null });

  errorsFor = (formKey) => {
    const { status } = this.props;
    return status.errorFormKey === formKey ? status.error : null;
  };

  render() {
    const {
      t, organizationId, leasingAgreements, status,
      createLeasingAgreement, updateLeasingAgreement, deleteLeasingAgreement,
    } = this.props;
    const { newFormKey } = this.state;

    return (
      <div style={styles.container}>
        {status.loading && <CBSpinnerFloating />}
        <CBHeaderTextWithHelp text={t('leasingAgreementsHeading')} />
        <p style={styles.description}>{t('leasingAgreementsDescription')}</p>
        {
          newFormKey && (
            <LeasingAgreementForm
              key={newFormKey}
              serverErrors={this.errorsFor(newFormKey)}
              loading={status.loading}
              onSave={(data) => createLeasingAgreement({ ...data, organization: organizationId }, newFormKey)}
              onCancel={this.closeNewForm}
            />
          )
        }
        {
          leasingAgreements.map((agreement) => (
            <LeasingAgreementForm
              key={agreement.id}
              agreement={agreement}
              serverErrors={this.errorsFor(agreement.id)}
              loading={status.loading}
              onSave={(data) => updateLeasingAgreement(agreement.id, data, organizationId)}
              onDelete={() => deleteLeasingAgreement(agreement.id, organizationId)}
            />
          ))
        }
        {
          !newFormKey && !status.loading && leasingAgreements.length === 0 && (
            <p style={styles.description}>{t('leasingAgreementsEmpty')}</p>
          )
        }
        {
          !newFormKey && (
            <CBButtonWithIconSmall
              icon='/img/icon_plus.svg'
              text={t('leasingAgreementAdd')}
              onClick={this.openNewForm}
            />
          )
        }
      </div>
    );
  }
}

const styles = {
  container: {
    position: 'relative',
    margin: '32px 0 16px 0',
  },
  description: {
    fontSize: 12,
    marginBottom: 16,
  },
};

function mapStateToProps(state) {
  return {
    leasingAgreements: state.leasingAgreement.leasingAgreements,
    savedFormKey: state.leasingAgreement.savedFormKey,
    status: state.leasingAgreement.leasingAgreementStatus,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchLeasingAgreements: _fetchLeasingAgreements,
    createLeasingAgreement: _createLeasingAgreement,
    updateLeasingAgreement: _updateLeasingAgreement,
    deleteLeasingAgreement: _deleteLeasingAgreement,
  },
)(translate('SettingsView')(StaffLeasingAgreements));
